import _isImplemented from "./is-implemented";
import _implementation from "./implementation";
var exports = {};
exports = _isImplemented() ? globalThis : _implementation;
export default exports;